<template>
  <div class="bq-join bq-box-jobs">
    <div class="bq-box-wrap">
      <ul class="bq-jobs-list">
        <li
          class="bq-jobs-item"
          v-for="(item, index) in jobs1"
          :key="index"
          @click="showJobDetail(index)"
        >
          <figure class="bq-jobs-img">
            <img
              style="width: 102px; height: 102px;"
              :src="item.icon"
              alt="item.name"
            />
          </figure>
          <div class="bq-jobs-title">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="bq-jobs-list">
        <li
          class="bq-jobs-item"
          v-for="(item, index) in jobs2"
          :key="index"
          @click="showJobDetail1(index)"
        >
          <figure class="bq-jobs-img">
            <img
              style="width: 102px; height: 102px;"
              :src="item.icon"
              alt="item.name"
            />
          </figure>
          <div class="bq-jobs-title">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="bq-jobs-list">
        <li
          class="bq-jobs-item"
          v-for="(item, index) in jobs3"
          :key="index"
          @click="showJobDetail3(index)"
        >
          <figure class="bq-jobs-img">
            <img
              style="width: 102px; height: 102px;"
              :src="item.icon"
              alt="item.name"
            />
          </figure>
          <div class="bq-jobs-title">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="bq-jobs-list">
        <li
          class="bq-jobs-item"
          v-for="(item, index) in jobs4"
          :key="index"
          @click="showJobDetail4(index)"
        >
          <figure class="bq-jobs-img">
            <img
              style="width: 102px; height: 102px;"
              :src="item.icon"
              alt="item.name"
            />
          </figure>
          <div class="bq-jobs-title">{{ item.name }}</div>
        </li>
      </ul>
    </div>

    <!-- job 的弹窗详情 -->
    <bq-dialog
      class="bq-dialog"
      :visible="visible"
      :onHide="hideJobDetail"
      :hideDialog="hideJobDetail"
    >
      <article
        class="bq-article-job"
        v-for="item in activeJob.description"
        :key="item.title"
      >
        <h4>{{ item.title }}</h4>
        <div class="bq-article-content">
          <p v-for="cell in item.content" :key="cell">{{ cell }}</p>
        </div>
      </article>

      <a
        class="bq-job-mail"
        :href="`mailto:${aboutData.info.email}`"
        target="_blank"
        slot="footer"
      >
        {{ aboutData.info.email }}
      </a>
    </bq-dialog>
  </div>
</template>
<script>
import BqDialog from '@/components/Dialog';

import { jobs1, jobs2, jobs3, jobs4, aboutData } from './job';
export default {
  name: 'Join',
  data() {
    return {
      jobs1,
      jobs2,
      jobs3,
      jobs4,
      visible: false,
      activeJob: {},
      aboutData,
    };
  },

  components: {
    BqDialog,
  },
  methods: {
    showJobDetail(index) {
      this.activeJob = this.aboutData.jobs1[index];
      this.visible = true;
    },
    showJobDetail1(index) {
      this.activeJob = this.aboutData.jobs2[index];
      this.visible = true;
    },
    showJobDetail3(index) {
      this.activeJob = this.aboutData.jobs3[index];
      this.visible = true;
    },
    showJobDetail4(index) {
      this.activeJob = this.aboutData.jobs4[index];
      this.visible = true;
    },
    hideJobDetail() {
      this.activeJob = {};
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';
.bq-box-jobs {
  width: 1200px;
  margin: 0 auto;
  .bq-box-wrap {
    margin: 90px auto;

    .bq-jobs-title {
      color: #333;
      font-size: 18px;
      margin: 20px 0 8px;
    }
    .bq-jobs-list {
      display: flex;
      justify-content: space-between;
      &:first-child {
        margin-bottom: 60px;
      }
      &:nth-child(2) {
        margin-bottom: 60px;
      }

      &:nth-child(3) {
        margin-bottom: 60px;
      }
      .bq-jobs-item {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: @textColorDark;
        text-align: center;
        cursor: pointer;

        .bq-jobs-img {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 102px;
          height: 102px;
          border-radius: 50%;
          transition: transform 0.3s;

          img {
            display: block;
          }
        }

        &:hover {
          .bq-jobs-img {
            transform: scale(1.1);
            .bgimg {
              width: 102px;
              height: 102px;
            }
          }
        }

        h4 {
          color: #333;
          font-size: 18px;
          margin-top: 20px;
        }
      }
    }
  }
}

.bq-dialog {
  .bq-article-job {
    margin-bottom: 30px;
    font-size: 14px;
    color: @textColorBase;

    h4 {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #056ed0;
    }

    .bq-article-content {
      letter-spacing: 1px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .bq-job-mail {
    display: block;
    width: 308px;
    height: 56px;
    line-height: 56px;
    margin: 0 auto;
    background: @themeColor;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    font-size: 16px;

    &:hover {
      background: lighten(@themeColor, 5%);
    }
  }
}
</style>
